var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarToggle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#6c767d",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 4.83A1.17 1.17 0 0 0 3.83 6v12c0 .646.524 1.17 1.17 1.17h5.17V4.83H5Zm6.83 0v14.34H19A1.17 1.17 0 0 0 20.17 18V6A1.17 1.17 0 0 0 19 4.83h-7.17ZM2.17 6A2.83 2.83 0 0 1 5 3.17h14A2.83 2.83 0 0 1 21.83 6v12A2.83 2.83 0 0 1 19 20.83H5A2.83 2.83 0 0 1 2.17 18V6Zm3 2A.83.83 0 0 1 6 7.17h2a.83.83 0 0 1 0 1.66H6A.83.83 0 0 1 5.17 8Zm0 2.5A.83.83 0 0 1 6 9.67h2a.83.83 0 1 1 0 1.66H6a.83.83 0 0 1-.83-.83Zm0 2.5a.83.83 0 0 1 .83-.83h2a.83.83 0 1 1 0 1.66H6a.83.83 0 0 1-.83-.83Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/sidebar-toggle.4d1cc491636df8133bcd859b45e9a78a.svg";
export { ForwardRef as ReactComponent };